import React from 'react';
import { List, ListItem, MainButton, LoadingShimmer } from '@icarros/ids-react';
import { useProposalsContext } from '../../../store/contexts/proposals';
import { ProposalsEmptyState } from './ProposalsEmptyState';
import { ListItemModifier, ProposalsContentWrapper, ProposalsWrapper } from '../style';
import { formatTimeFrom } from '../../../utils/formatters';
import { Header } from './Header';
import { PhoneScamNotify } from '../../../components/PhoneScamNotify';
import { pushSellerPFDashboardEvent } from '../../../../utils/pushToDataLayer';

export function Messages(): JSX.Element {
  const {
    loading,
    proposals,
    pageable,
    setFetchNextPage,
    fetchingNextPage,
    setCurrentProposal,
    currentProposal,
    transition
  } = useProposalsContext();

  return (
    <ProposalsWrapper isMessageOpen={!!currentProposal} isTransition={transition}>
      <ProposalsContentWrapper>
        <Header />

        <PhoneScamNotify
          handleCardClick={() =>
            pushSellerPFDashboardEvent('confira mais dicas', 'seguranca', {
              location: 'mensagens recebidas'
            })
          }
          handleMainButtonModalClick={() =>
            pushSellerPFDashboardEvent('entendi', 'modal seguranca', {
              location: 'mensagens recebidas'
            })
          }
          handleCloseModalClick={() =>
            pushSellerPFDashboardEvent('fechar', 'modal seguranca', {
              location: 'mensagens recebidas'
            })
          }
        />

        {loading && (
          <>
            <LoadingShimmer show height="50px" width="380px" />
            <LoadingShimmer show height="50px" width="380px" />
          </>
        )}
        {!loading && proposals?.length === 0 && <ProposalsEmptyState />}
        {proposals && proposals.length > 0 && (
          <>
            <List>
              {proposals.map(proposal => (
                <ListItemModifier key={proposal.id}>
                  <ListItem
                    label={proposal.compradorNome}
                    subLabel={proposal.compradorMensagem}
                    variant="action"
                    descript={formatTimeFrom(proposal.data, 'narrow')}
                    actionOnClick={() => setCurrentProposal(proposal)}
                  />
                </ListItemModifier>
              ))}
            </List>

            {pageable && !pageable.isLastPage && (
              <MainButton
                onClick={() => setFetchNextPage(pageable.nextPage)}
                variant="secondary"
                text="carregar mais"
                isLoading={fetchingNextPage}
              />
            )}
          </>
        )}
      </ProposalsContentWrapper>
    </ProposalsWrapper>
  );
}
